import { FC } from 'react';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Moment } from 'moment';
import styles from './periodShiftButtons.module.less';

interface PeriodShiftButtonsProps {
  dateRange: [Moment, Moment] | null;
  onDateRangeChange: (range: [Moment, Moment]) => void;
}

/**
 * Prev/next circle arrows that shift the range by its own length (inclusive days),
 * landing on the adjacent, non-overlapping period. Shared by every profile tab
 * that has a date filter.
 */
const PeriodShiftButtons: FC<PeriodShiftButtonsProps> = ({ dateRange, onDateRangeChange }) => {
  const shift = (direction: -1 | 1) => {
    if (!dateRange) return;

    const days = dateRange[1].diff(dateRange[0], 'days') + 1;
    if (days <= 0) return;

    const offset = direction * days;
    onDateRangeChange([dateRange[0].clone().add(offset, 'days'), dateRange[1].clone().add(offset, 'days')]);
  };

  return (
    <>
      <Button
        size="large"
        shape="circle"
        className={styles.navButton}
        aria-label="Previous period"
        icon={<LeftOutlined />}
        disabled={!dateRange}
        onClick={() => shift(-1)}
      />
      <Button
        size="large"
        shape="circle"
        className={styles.navButton}
        aria-label="Next period"
        icon={<RightOutlined />}
        disabled={!dateRange}
        onClick={() => shift(1)}
      />
    </>
  );
};

export default PeriodShiftButtons;
